import script from "./auth.vue?vue&type=script&setup=true&lang=js"
export * from "./auth.vue?vue&type=script&setup=true&lang=js"

import "./auth.vue?vue&type=style&index=0&id=e5066620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5066620"]])

export default __exports__